import { ChakraProvider } from '@chakra-ui/react'
import VirtualLine from './Apps/VirtualLine'
import theme from './Utils/Theme'
import { QueryClient, QueryClientProvider } from 'react-query'
import VirtualWalkways from './Apps/VirtualWalkways'
export const App = () => {
	const queryClient = new QueryClient()

	return (
		<QueryClientProvider client={queryClient}>
			<ChakraProvider theme={theme}>
				<VirtualLine />
				<VirtualWalkways />
			</ChakraProvider>
		</QueryClientProvider>
	)
}
